import { render, staticRenderFns } from "./images.vue?vue&type=template&id=e2c45d70&scoped=true&"
import script from "./images.vue?vue&type=script&lang=js&"
export * from "./images.vue?vue&type=script&lang=js&"
import style0 from "./images.vue?vue&type=style&index=0&id=e2c45d70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c45d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2c45d70')) {
      api.createRecord('e2c45d70', component.options)
    } else {
      api.reload('e2c45d70', component.options)
    }
    module.hot.accept("./images.vue?vue&type=template&id=e2c45d70&scoped=true&", function () {
      api.rerender('e2c45d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/images.vue"
export default component.exports